import React from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useState, useEffect } from "react";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useNavigate } from "react-router-dom";

const MyPerformanceEvaluationReport = () => {
  const navigate = useNavigate();
  const columns = {
    AppraisalCycle: { text: "Appraisal Cycle", visible: true },
    Reviewer: { text: "Reviewer", visible: true },
    EvaluationDate: {
      text: "Evaluation Date",
      align: "center",
      format: "date",
      visible: true
    },
    Status: { text: "Status", align: "center", visible: true },
  };
  const defaultColumns = {
    AppraisalCycle: true,
    Reviewer: true,
    EvaluationDate: true,
    Status: true,
  };

  const [reportList, setReplortList] = useState([]);
  const [appraisalCycle, setAppraisalCycle] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchReportList();
  }, [searchTerm]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("My Performance Evaluation Report"))
  }, [])


  const [apiStatus, setApiStatus] = useState("")

  const fetchReportList = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/2?P_AppraisalCycleID=${0}`
      );
      setApiStatus(response?.status)
      if (response?.status === 200) {
        setReplortList(response?.data?.header);
        const cycleOpts = response?.data?.appraisalCycle?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        cycleOpts.unshift({ value: 0, label: "Select" });
        setAppraisalCycle(cycleOpts);
      }
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };

  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/2?P_AppraisalCycleID=${filterFormData.find((o) => o.label === "Appraisal Cycle")
          ? filterFormData.find((o) => o.label === "Appraisal Cycle").value
          : 0
        }`
      );

      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response.data.headers;
        setReplortList(response.data.header);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Apprisal Cycle. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Apprisal Cycle", error);
    }
  };
  const formDatas = [
    {
      name: "Appraisal Cycle",
      type: "Select",
      options: [...appraisalCycle],
    },
  ];

  const [filterFormData, setFilterData] = useState([]);

  const handleFilterChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleView = (id) => {
    navigate(`/pr-evaluation-report/${id.ID}`);
  };
  const handleFilterReset = () => {
    // Reset to empty/default values without passing any specific data
    setFilterData([]);
    fetchReportList();
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid " id="skill-table-area">
          <div className="box-body table-responsive container-fluid ">
            <div className="row mt-2">
              <Dynamic_PR_table
                data={reportList}
                columns={columns}
                defaultColumns={defaultColumns}
                itemsPerPage={8}
                isRequiredStatus={true}
                isApiStatus={apiStatus}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={false}
                showIcon2={false}
                showIcon3={true}
                showIcon4={false}
                showIcon5={false}
                formDatas={formDatas}
                filterFormData={filterFormData}
                handleGetData={handleGetData}
                isActionRequired={true}
                isFilterRequired={true}
                isCheckBoxRequired={false}
                // handleIcon1={handleEdit}
                handleIcon3={handleView}
                handleChange={handleFilterChange}
                handleReset={handleFilterReset}
                add
                more
                function
                icons={{
                  Icon1: <i class="bi bi-pencil-square  icons"></i>,
                  Icon2: <i class="bi bi-trash-fill icons"></i>,
                  Icon3: <i class="bi bi-eye-fill icons"></i>,
                  Icon3Text: "View",
                  Icon4: <i class="bi bi-person-plus icons"></i>,
                  Icon4Text: "Create Employee",
                }}
              />
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default MyPerformanceEvaluationReport;
